import useUrlQuery from 'Src/hooks/useUrlQuery';
import { useQuery } from 'Utils/hooks/useQuery';
import { isFlutterInAppWebEnabled } from 'Utils/events/flutterWebView';

const MOBILE_DESIGN_VALUE = 'mobile';
const WEB_DESIGN_VALUE = 'web';
const APP_DESIGN_KEY = 'design';
const EMBEDDED_KEY = 'has_embedded_flow';
const WAIT_MOBILE_SESSION_KEY = 'wait_mobile_session';

export const isFromAppMobile = () => {
  const isFlutterWebview = isFlutterInAppWebEnabled();
  const query = useQuery();

  const designQueryParam = query.get(APP_DESIGN_KEY);

  if (designQueryParam === MOBILE_DESIGN_VALUE) {
    localStorage.setItem(APP_DESIGN_KEY, MOBILE_DESIGN_VALUE);
  } else if (designQueryParam && designQueryParam !== MOBILE_DESIGN_VALUE) {
    localStorage.removeItem(APP_DESIGN_KEY);
  }

  const storedDesignValue = localStorage.getItem(APP_DESIGN_KEY);

  return storedDesignValue === MOBILE_DESIGN_VALUE || isFlutterWebview;
};

export const isFromAppMobileWaitSession = () => {
  const isFlutterWebview = isFlutterInAppWebEnabled();

  const query = new URLSearchParams(window.location.search);

  const waitSessionQueryParam = query.get(WAIT_MOBILE_SESSION_KEY);

  if (waitSessionQueryParam === 'true') {
    localStorage.setItem(WAIT_MOBILE_SESSION_KEY, waitSessionQueryParam);
  } else if (waitSessionQueryParam && waitSessionQueryParam === 'false') {
    localStorage.removeItem(WAIT_MOBILE_SESSION_KEY);
  }

  const storedWaitSessionValue = localStorage.getItem(WAIT_MOBILE_SESSION_KEY);

  return isFlutterWebview && (storedWaitSessionValue === 'true');
};

export const isFromAppMobileStored = () => {
  const storedDesignValue = localStorage.getItem(APP_DESIGN_KEY);

  return storedDesignValue === MOBILE_DESIGN_VALUE;
};

export const getAppDesign = () => {
  const query = new URLSearchParams(window.location.search);
  const designParam = query.get(APP_DESIGN_KEY) || localStorage.getItem(APP_DESIGN_KEY);

  return designParam === MOBILE_DESIGN_VALUE ? MOBILE_DESIGN_VALUE : WEB_DESIGN_VALUE;
};

export const hasMobileDesignParam = () => (
  getAppDesign() === MOBILE_DESIGN_VALUE
);

export const isMobileDesign = () => {
  const isFlutterWebview = isFlutterInAppWebEnabled();
  return hasMobileDesignParam() || isFlutterWebview;
};

export const isEmbeddedAmazon = () => {
  const params = useUrlQuery();
  const src = String(params?.src).toUpperCase();
  const mode = String(params?.mode).toUpperCase();

  const hasEmbeddedParams = src === 'AMZ' && mode === 'APP';
  const storedEmbeddedFlow = sessionStorage.getItem(EMBEDDED_KEY) === 'true';

  if (hasEmbeddedParams) sessionStorage.setItem(EMBEDDED_KEY, 'true');

  return hasEmbeddedParams || storedEmbeddedFlow;
};

export const isMobileWaitSession = () => {
  const query = new URLSearchParams(window.location.search);
  return query.get(WAIT_MOBILE_SESSION_KEY) === 'true';
};
